import { Controller } from '@hotwired/stimulus';

// Small companion controller for the range-picker that lives at the top of
// each measurement region for frameworks whose config exposes
// `scale_range_choices` (Numeric scale, or any framework that adds them).
//
// Behavior: when the preset <select> changes, autofill the min/max number
// inputs. Picking the "Custom" option leaves them as-is so the user can
// type their own bounds. Typing directly into min/max leaves the preset
// alone — the inputs are always the source of truth that gets submitted.
export default class extends Controller {
  static targets = ['min', 'max'];

  presetChanged(event) {
    const value = event.currentTarget.value;
    if (!value) return; // "Custom" — leave the inputs alone
    const [min, max] = value.split('-');
    if (this.hasMinTarget && min !== undefined) this.minTarget.value = min;
    if (this.hasMaxTarget && max !== undefined) this.maxTarget.value = max;
  }
}
